export default __webpack_public_path__ + "static/media/AddNewGroup.31c259fe.png";